import './config'; // This import sets the compass config singleton

import { CompassVariant } from '@scale/genai-compass-shared/compassVariants';
import { type ExternalContext } from '@scale/compass-shared/types';
import { CompassSessionKey } from '@scale/compass-shared/CompassSession';
import CompassProvider from '@scale/compass-ui/components/CompassProvider';
import CompassEmbedUI from '@scale/compass-ui/components/CompassEmbedUI';
import { useEnabledCardTypes } from 'react-scale/corp/views/DataCompassV2/hooks/useEnabledCardTypes';
import useQueryCompassFeatureFlags from 'react-scale/corp/views/DataCompassV2/hooks/useQueryCompassFeatureFlags';

export interface CompassEmbedProps {
  // Core session props
  sessionInitFn?: () => Promise<CompassSessionKey>;

  // Metadata
  compassVariant: CompassVariant;
  externalContext: ExternalContext;
  showHeader?: boolean;
  hideWorkflowHeader?: boolean;
}

export default function CompassEmbed({
  sessionInitFn,
  compassVariant,
  externalContext,
  showHeader = true,
  hideWorkflowHeader,
}: CompassEmbedProps) {
  const enabledCardTypes = useEnabledCardTypes(compassVariant);
  const featureFlags = useQueryCompassFeatureFlags(externalContext.runByUser!);
  return (
    <CompassProvider
      compassName={compassVariant}
      user={externalContext.runByUser!}
      projectId={externalContext.projectId}
      enabledCardTypes={enabledCardTypes}
      featureFlags={featureFlags}
    >
      <CompassEmbedUI
        sessionInitFn={sessionInitFn}
        showHeader={showHeader}
        hideWorkflowHeader={hideWorkflowHeader}
      />
    </CompassProvider>
  );
}
